import { render, staticRenderFns } from "./EmployeeStatements.vue?vue&type=template&id=752a7078&scoped=true"
import script from "./EmployeeStatements.vue?vue&type=script&lang=js"
export * from "./EmployeeStatements.vue?vue&type=script&lang=js"
import style0 from "./EmployeeStatements.vue?vue&type=style&index=0&id=752a7078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a7078",
  null
  
)

export default component.exports